<template>
  <v-card class="pa-4">
    <v-card-text class="pb-0">
      <p class="pa-3 mb-0">
        Are you sure you want to delete the home card for <span class="font-weight-bold">{{ deleteLabelHome }}</span>?
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="coolgray"
        text
        @click.stop="cancelDeleteHome"
      >
        Cancel
      </v-btn>

      <v-btn
        color="toasted"
        text
        @click.stop="deleteHomeAndResetForm(deleteIndexHome)"
      >
        Delete it
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import HomeMixin from 'src/home/store/utils/home-mixin'

export default {
  name: 'HomeDelete',
  mixins: [
    HomeMixin,
  ],
}
</script>
